export const BUTTON_TYPES = [
  'default',
  'none',
  'primary',
  'primary-next',
  'black-primary',
  'secondary',
  'secondary-next',
  'tertiary',
  'tertiary-next',
  'subtle',
  'secondary-inline',
  'secondary-inline-next',
  'link',
  'link-next',
  'link-dark',
  'link-secondary',
  'link-black',
  'danger',
  'warning',
  'tour',
  'ghost',
  'ghost-next',
  'modern',
  'simple',
  'simple-next',
  'success',
  'outline'
]

export const BUTTON_SIZES = {
  XSS: 'xss',
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  XMD: 'xmd',
  LG: 'lg',
  XLG: 'xlg',
  XSM: 'xsm',
  LG_NEXT: 'lg-next'
}

export const BUTTON_VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SECONDARY_GRAY: 'secondary-gray',
  TERTIARY: 'tertiary',
  TERTIARY_GRAY: 'tertiary-gray',
  LINK: 'link',
  LINK_GRAY: 'link-gray'
}

export const BUTTON_SIZES_NEXT = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
  XXL: 'xxl'
}

export const BUTTON_ICON_DENSITIES = {
  DEFAULT: 'default',
  FIT: 'fit'
}
